export const FETCH_EVENTS_PAGE = '@@events-page/FETCH_EVENTS_PAGE';
export const FETCH_EVENTS_PAGE_SUCCESS = '@@events-page/FETCH_EVENTS_PAGE_SUCCESS';
export const FETCH_EVENTS_PAGE_ERROR = '@@events-page/FETCH_EVENTS_PAGE_ERROR';

export const FETCH_EVENTS_FILTERS = '@@events-page/FETCH_EVENTS_FILTERS';
export const FETCH_EVENTS_FILTERS_SUCCESS = '@@events-page/FETCH_EVENTS_FILTERS_SUCCESS';
export const FETCH_EVENTS_FILTERS_ERROR = '@@events-page/FETCH_EVENTS_FILTERS_ERROR';
